var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthyTab2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343.152 32.0003C332.105 21.7158 317.573 15.998 302.48 15.998C287.387 15.998 272.855 21.7158 261.808 32.0003L256 37.5123L250.192 32.0003C239.145 21.7158 224.613 15.998 209.52 15.998C194.427 15.998 179.895 21.7158 168.848 32.0003C160.232 39.9872 154.539 50.6288 152.676 62.2283C150.813 73.8277 152.887 85.717 158.568 96.0003H16V112H171.752L174.656 114.76L256 192L337.344 114.76L340.248 112H496V96.0003H353.432C359.113 85.717 361.187 73.8277 359.324 62.2283C357.461 50.6288 351.768 39.9872 343.152 32.0003ZM304 112H284.528L262.856 148.12C262.145 149.304 261.14 150.283 259.939 150.963C258.737 151.643 257.38 152 256 152C255.668 152.003 255.337 151.981 255.008 151.936C253.469 151.744 252.019 151.109 250.834 150.107C249.65 149.106 248.782 147.782 248.336 146.296L231.704 90.8643L226.656 106.464C226.135 108.072 225.119 109.474 223.752 110.469C222.385 111.464 220.738 112 219.048 112H184V96.0003H213.224L224.424 61.5363C224.885 59.8813 225.894 58.432 227.286 57.4261C228.679 56.4202 230.372 55.9174 232.088 56.0003C233.794 56.019 235.449 56.5825 236.812 57.6087C238.175 58.6349 239.174 60.0699 239.664 61.7043L258.456 124.352L273.144 99.8803C273.855 98.697 274.86 97.7178 276.061 97.0379C277.263 96.358 278.62 96.0005 280 96.0003H304V112Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152 272V384H192V496H320V384H360V272H328V352H184V272H152Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 344C273.673 344 288 329.673 288 312C288 294.327 273.673 280 256 280C238.327 280 224 294.327 224 312C224 329.673 238.327 344 256 344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthyTab2Icon);
export default __webpack_public_path__ + "static/media/Healthy_tab2_icon.f794eb545166c398757e1786357ac6e2.svg";
export { ForwardRef as ReactComponent };